import { render, staticRenderFns } from "./NewsletterBanner.vue?vue&type=template&id=68b2b943&"
import script from "./NewsletterBanner.ts?vue&type=script&lang=ts&"
export * from "./NewsletterBanner.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports